import {
  EBaseTextSize,
  EBaseTextWeight,
  EBaseTextPosition,
  BaseText,
} from '@spinwise/react-component-library/BaseText';
import { OVERLAY_CMS_PAGE_SHOW } from '@spinwise/spinwise-core';
import classNames from 'classnames';
import { Trans } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { EBrandTextColor } from 'Libraries/typography.library';
import { EPageSlugs } from 'Types/globals';
import styles from './TermsDisclaimer.module.scss';
import useLicencedTerms from 'Hooks/useLicencedTerms';
import { EOverlayContentWidth, POSITIONS } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';

const TermsDisclaimer = () => {
  const dispatch = useDispatch();
  const termsSlug = useLicencedTerms();

  const handleModalClick = (slug: string) => {
    dispatch({
      type: OVERLAY_CMS_PAGE_SHOW,
      data: {
        show: true,
        data: {
          slug: slug,
          position: POSITIONS.TOP,
          contentWidth: EOverlayContentWidth.LARGE,
        },
      },
    });
  };

  return (
    <div className={classNames(styles.terms_container, styles.shadow, 'd-fl ai-c jc-c')}>
      {
        <BaseText
          //@ts-ignore
          value={
            <Trans
              components={{
                a: (
                  <span
                    onClick={() => handleModalClick(termsSlug)}
                    className={classNames(EBrandTextColor.Terms, styles.terms_link)}
                  ></span>
                ),
                b: (
                  <span
                    onClick={() => handleModalClick(EPageSlugs.PRIVACY_POLICY)}
                    className={classNames(EBrandTextColor.Terms, styles.terms_link)}
                  ></span>
                ),
              }}
            >
              top.banner.disclaimer.agreement
            </Trans>
          }
          size={EBaseTextSize.Small}
          weight={EBaseTextWeight.W400}
          alignment={EBaseTextPosition.Center}
          color={EBrandTextColor.Terms}
        />
      }
    </div>
  );
};

export default TermsDisclaimer;
